import { useQuery } from 'react-query';
import { ApiResponse } from './types';
import { AxiosService } from 'api/axiosService';

interface Profile {
  client: {
    email: string;
    firstname: string;
    lastname: string;
  };
  limits: {
    bandwidth: string;
    disk: string;
    sites: number;
    visitors: number;
  };
  package: {
    account_type: string;
    next_due_date: string;
    package_id: number;
    plan: string;
    start_date: string;
  };
  usage: {
    bandwidth: number;
    disk: number;
    sites: number;
    visitors: number;
  };
}

export const useProfile = () => {
  return useQuery(
    'profile',
    async () => await AxiosService.get<ApiResponse<Profile>>(`account/me`)
  );
};
